<template>
  <div id="chats">
    <Navbar current="Psicólogos" />
    <Sidebar />
    <Container col="col-12">
      <Header :headerClass="'mb-0'" :headerBodyClass="'pb-0 border-0'" :isSubHeader="false" title="Psicólogos"
        subtitle="Registro dos psicólogos" :iconClass="'fas fa-user-md text-primary'" :totalCount="total">
        <template slot="button">
          <FilterPanel :fields="fields" :value="filters" :showChips="false" @apply="applyFilters" />
        </template>
      </Header>

      <div v-if="Object.keys(filters).length" class="mt-4 mb-4">
        <FilterPanel :fields="fields" :value="filters" :showButton="false" @apply="applyFilters" />
      </div>
      <div v-else class="mb-4"></div>

      <PsychologistsList :propFilters="filters" @totalItemsChanged="total = $event.total" />
    </Container>
  </div>
</template>

<script>
import PsychologistsController from "./PsychologistsController";
export default PsychologistsController;
</script>
